import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _AdquisitionItem } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";

export interface FunctionalIDPlanSelectResult {
    IDAdquisitionPlanFunctionalID: number;
    IDLnFunctionalIDName: string;
    IDAccount: number;
}

interface BaseProps {
    label?: string;
    idPlan?: number;
    IDSelect?: number;
    onChange: (value: FunctionalIDPlanSelectResult) => void;
}

export const EditorAdquisitionPlanFunctionalIDByPlan = ({ label, onChange, IDSelect, idPlan }: BaseProps) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_AdquisitionItem);

    const [valor, setValor] = useState<string>("");

    const [modal, setModal] = useState<any>({ name: 'Areas Funcionales Disponibles', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (IDSelect && IDSelect != bean.IDAdquisitionPlanFunctionalID) {
            instance.getAdquisitionPlanFunctionalID(IDSelect).then(
                (resp) => {
                    setValor(`${resp.IDAdquisitionPlanFunctionalID} - ${resp.IDLnFunctionalIDName}`);
                    (onChange as (value: FunctionalIDPlanSelectResult) => void)(resp);
                }
            )
        }
    }, [IDSelect])



    useEffect(() => {
        if (idPlan) {
            getLista();
        }
    }, [idPlan])

    const returnData = () => {
        if (!bean.IDAdquisitionPlanFunctionalID) {
            toast.error("Area funcional no valida");
        } else {
            setValor(`${bean.IDAdquisitionPlanFunctionalID} - ${bean.IDLnFunctionalIDName}`);

            (onChange as (value: FunctionalIDPlanSelectResult) => void)(bean);

            setModal({ ...modal, view: false });
        }
    };

    const getLista = () => {
        instance.getAdquisitionPlanFunctionalIDCatalog(idPlan).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: "IDAdquisitionPlanFunctionalID", mask: MASK_NUMBER, visible: false },
        { title: 'Área Funcional', property: 'IDLnFunctionalIDName' },
        { title: 'Responsable en el área funcional', property: 'AccountName' },
        { title: 'Jefe de área', property: 'BossName' },
        // { title: 'Observaciones', property: 'Observations', visible: false },
        // { title: 'Valor Estimado', property: 'EstimatedValue', visible: false, mask: MASK_MONEY },
        // { title: 'Valor Necesidades', property: 'TotalValue', mask: MASK_MONEY },

    ]

    const clearSelection = () => {
        setValor("");
        (onChange as (value: FunctionalIDPlanSelectResult | null) => void)(null as any);
        setBean({});
    };


    return (
        <>
            <label>{label ?? "Area Funcional"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: '35px', cursor: "pointer" }}
                onClick={() => setModal({ ...modal, view: true })}
            >
                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}